import { Flex, Link, Text } from '@chakra-ui/react';
import { ReactComponent as OutlineInfoIcon } from 'assets/icons/outline_info.svg';
import { HEADINGS_HELP_LINK } from 'constants/links';
import { Toggletip } from 'modules/common/components/Toggletip';
import { useTranslation } from 'react-i18next';

export const Heading = () => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu' });

  return (
    <Flex fontSize='sm' fontWeight='md' pb='2'>
      <Text mr={2}>{t('textMenu.heading')}</Text>
      <Toggletip
        hasArrow
        placement={'right-start'}
        icon={<OutlineInfoIcon color='var(--vg-colors-upgrade-blue-500)' />}
        buttonAriaLabel={t('textMenu.tooltipLabel')}
      >
        <Text size={'sm'} mb={2} textAlign={'left'}>
          {t('textMenu.description')}
        </Text>
        <Link variant={'inline-dark'} w={'fit-content'} href={HEADINGS_HELP_LINK} isExternal>
          {t('textMenu.learnMore')}
        </Link>
      </Toggletip>
    </Flex>
  );
};
